import { TimelineTimeframe } from '@wilson/interfaces';
import { startOfMinute } from 'date-fns';

export function getDateFromPixelPosition({
  pixelPosition,
  frameLength,
  timeframe,
}: {
  pixelPosition: number;
  timeframe: TimelineTimeframe;
  frameLength: number;
}): Date {
  const totalDurationInMillisecond = timeframe.end - timeframe.start;

  const millisecondsFromStart =
    (pixelPosition / frameLength) * totalDurationInMillisecond;

  const date = startOfMinute(new Date(timeframe.start + millisecondsFromStart));
  return date;
}
